module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/envato-ca7c490f4a4c6c512a8c79fc1c006b1c.svg";